module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/3@2x_ae17c64f10ba3789a791190c521d3119.png";